import React from "react";
import Header from "./panel/Header";
import Sidebar from "./panel/Sidebar";
import { Outlet } from "react-router";

const DashboardLayout = () => {
  return (
    <div className="bg-white min-h-[calc(100vh-116px)]">
      <Header />
      <div className="bg-white w-full flex justify-between items-stretch sm:gap-10 gap-4 pt-5 sm:pr-16 pr-4">
        <Sidebar />
        <div className="flex-grow">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
